import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Interactive } from "react-interactive";
import Card from "~components/atoms/card/card";
import Heading from "~components/atoms/heading/heading";
import LinkWrapper from "~components/utils/link_wrapper/link_wrapper";
import useHandleInteractiveStateChange from "~hooks/use_handle_interactive_state_change/use_handle_interactive_state_change";
import { LINK } from "../../../../prop_types";
import {
  chapterCardInnerStyle,
  currentChapterStyle,
  linkWrapperStyle,
} from "./sr_chapter_card.module.scss";

function SrChapterCard({
  callbackOnClick,
  chapterNumber,
  link,
  title,
  isCardActive,
}) {
  const [isActive, handleInteractiveStateChange] =
    useHandleInteractiveStateChange();

  const chapterNumberColor = isActive ? "azure" : "gray";

  if (isCardActive || !link) {
    return (
      <Card isRaised={isActive} isFullWidth stretch>
        <div className={classNames(chapterCardInnerStyle, currentChapterStyle)}>
          <Heading visualLevel={6} isBaseFontWeight seoLevel={4}>
            {title}
          </Heading>
          <Heading
            visualLevel={1}
            isXL
            isBaseFontWeight
            color="azure"
            seoLevel={4}
            noMargin
          >
            {chapterNumber}
          </Heading>
        </div>
      </Card>
    );
  }

  return (
    <Interactive
      as={LinkWrapper}
      stretch
      link={link}
      onStateChange={handleInteractiveStateChange}
      className={linkWrapperStyle}
      onClick={callbackOnClick}
    >
      <Card isRaised={isActive} isFullWidth stretch>
        <div className={chapterCardInnerStyle}>
          <Heading visualLevel={6} isBaseFontWeight seoLevel={4}>
            {title}
          </Heading>
          <Heading
            visualLevel={1}
            isXL
            isBaseFontWeight
            color={chapterNumberColor}
            seoLevel={4}
            noMargin
          >
            {chapterNumber}
          </Heading>
        </div>
      </Card>
    </Interactive>
  );
}

SrChapterCard.propTypes = {
  callbackOnClick: PropTypes.func,
  chapterNumber: PropTypes.number,
  isCardActive: PropTypes.bool,
  link: LINK,
  title: PropTypes.string,
};

SrChapterCard.defaultProps = {
  callbackOnClick: () => {},
  chapterNumber: 0,
  isCardActive: false,
  link: null,
  title: null,
};

export default SrChapterCard;
